import { render, staticRenderFns } from "./StudentProfileRecognitionsList.vue?vue&type=template&id=712631cf&scoped=true&"
import script from "./StudentProfileRecognitionsList.vue?vue&type=script&lang=js&"
export * from "./StudentProfileRecognitionsList.vue?vue&type=script&lang=js&"
import style0 from "./StudentProfileRecognitionsList.vue?vue&type=style&index=0&id=712631cf&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712631cf",
  null
  
)

export default component.exports